// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { View, Button, SchemaTable } from "@components";
import type { RtwLateSubmissionReason } from "@modules/service/reducer/rtw/types";

type OwnProps = $Exact<{
  data: Array<RtwLateSubmissionReason>,
  schema: Object,
  onChange?: Function,
  onSubmit?: Function,
  editing?: boolean,
  disabled?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class RtwReasonForLateSubmission extends React.Component<Props> {
  get defaultReasons() {
    return [
      {
        reason: null,
        isActive: true,
        id: null,
      },
    ];
  }

  get data() {
    return this.props.data || this.defaultReasons;
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      "ui:order": ["reason"],
      reason: {
        "ui:widget": "text",
        "ui:title": "Reason",
        "ui:options": {
          editable: true,
          disabled: false,
        },
      },
    };
  }

  handleAdd = () => {
    this.props.onChange && this.props.onChange([...this.data, ...this.defaultReasons]);
  };

  handleChange = (data: Array<Object>) => {
    this.props.onChange && this.props.onChange(data);
  };

  render() {
    return (
      <View>
        {!this.props.disabled && (
          <View alignItems="center" direction="row" justifyContent="space-between">
            <h6>{this.props.t("RETURN_TO_WORK_DETAILS_REASONS_LATE_SUBMISSION")}</h6>{" "}
            <Button
              materialIcon="add_circle"
              className="link alert-sgs__add-button"
              onClick={this.handleAdd}
            >
              {this.props.t("ADD")}
            </Button>
          </View>
        )}
        {this.schema && this.uiSchema && (
          <SchemaTable
            tableData={this.data}
            schema={this.schema}
            uiSchema={this.uiSchema}
            disabled={!!this.props.disabled}
            onChange={this.handleChange}
            allowDeletes
          />
        )}
      </View>
    );
  }
}

export default localize()(RtwReasonForLateSubmission);
